import Vue from 'vue';

const toast = {
  callToast(color, text) {
    alert(text);
    // Toastify({
    //   text,
    //   duration: 3000,
    //   newWindow: true,
    //   close: true,
    //   gravity: 'top',
    //   position: 'right',
    //   backgroundColor: color,
    //   stopOnFocus: true,
    // }).showToast();
  },
  error(text) {
    this.callToast('#EF4444', text);
  },
  warning(text) {
    this.callToast('#F59E0B', text);
  },
  success(text) {
    this.callToast('#10B981', text);
  },
  default(text) {
    this.callToast('#3B82F6', text);
  },
};

Vue.prototype.$toast = toast;

export default toast;
